"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.string.pad-start");
var _shopList = require("@/api/shop/shopList");
var _wechatEvaluate = require("@/api/evaluate/wechatEvaluate");
var _dishEvaluate = require("@/api/evaluate/dishEvaluate");
var _evaluateLabel = require("@/api/evaluate/evaluateLabel");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'dishAnalysis',
  data: function data() {
    // 设置默认日期范围为近三个月
    var endDate = new Date();
    var startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);
    var formatDateTime = function formatDateTime(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return {
      storeList: [],
      tableLoading: true,
      // 搜索表单数据
      searchForm: {
        startDate: formatDateTime(startDate) + ' 00:00:00',
        endDate: formatDateTime(endDate) + ' 23:59:59'
      },
      // 表格数据
      tableData: [],
      // 分页相关
      currentPage: 1,
      pageSize: 30,
      total: 0,
      // 标签设置相关
      labelDialogVisible: false,
      editLabelDialogVisible: false,
      activeLabelTab: 'positive',
      positiveLabels: [],
      negativeLabels: [],
      newPositiveLabel: '',
      newPositiveSort: 1,
      newNegativeLabel: '',
      newNegativeSort: 1,
      editLabelForm: {
        id: null,
        labelName: '',
        sortOrder: 1,
        labelType: 1,
        status: 1
      }
    };
  },
  created: function created() {
    this.getShops();
    this.handleSearch();
  },
  methods: {
    //时间转换
    formatDate: function formatDate(date) {
      var formatB = function formatB(t) {
        return new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).format(new Date(+t)).replace(/\//g, '-').replace(/\s/, ' ').replace(/:/g, ':');
      };
      return formatB(date);
    },
    // 搜索方法
    handleSearch: function handleSearch() {
      console.log('搜索条件:', this.searchForm);
      this.currentPage = 1;
      this.loadData();
    },
    // 导出方法
    handleExport: function handleExport() {
      var _this = this;
      this.$message.success('开始下载消息数据');
      // 这里可以调用API下载数据
      (0, _dishEvaluate.downloadEvaluationList)(this.searchForm).then(function (res) {
        _this.$message.success('导出成功，请到导出日志下载');
      });
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 加载数据
    loadData: function loadData() {
      var _this2 = this;
      this.tableLoading = true;
      console.log('加载菜品分析数据 - 页码:', this.currentPage, '每页:', this.pageSize);
      var params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
        page: this.currentPage,
        limit: this.pageSize
      });
      (0, _dishEvaluate.getGoodEvaluateList)(params).then(function (res) {
        console.log('菜品分析数据:', res);
        _this2.tableData = res.records;
        _this2.total = res.total || 0;
        _this2.tableLoading = false;
      }).catch(function (err) {
        console.error('加载失败:', err);
        _this2.tableLoading = false;
        _this2.$message.error('加载数据失败');
      });
    },
    // ========== 标签设置相关方法 ==========
    // 显示标签设置对话框
    showLabelSettings: function showLabelSettings() {
      this.labelDialogVisible = true;
      this.loadLabels();
    },
    // 关闭标签设置对话框
    closeLabelDialog: function closeLabelDialog() {
      this.activeLabelTab = 'positive';
      this.newPositiveLabel = '';
      this.newPositiveSort = 1;
      this.newNegativeLabel = '';
      this.newNegativeSort = 1;
    },
    // 加载标签数据
    loadLabels: function loadLabels() {
      var _this3 = this;
      (0, _evaluateLabel.getEvaluateLabelList)().then(function (res) {
        var allLabels = res.data || [];
        _this3.positiveLabels = allLabels.filter(function (item) {
          return item.labelType === 1;
        });
        _this3.negativeLabels = allLabels.filter(function (item) {
          return item.labelType === 2;
        });
      }).catch(function (err) {
        _this3.$message.error('加载标签失败');
      });
    },
    // 添加好评标签
    addPositiveLabel: function addPositiveLabel() {
      var _this4 = this;
      if (!this.newPositiveLabel.trim()) {
        this.$message.warning('请输入标签名称');
        return;
      }
      var data = {
        labelName: this.newPositiveLabel.trim(),
        labelType: 1,
        sortOrder: this.newPositiveSort || this.positiveLabels.length + 1,
        status: 1
      };
      (0, _evaluateLabel.saveEvaluateLabel)(data).then(function () {
        _this4.$message.success('添加成功');
        _this4.newPositiveLabel = '';
        _this4.newPositiveSort = _this4.positiveLabels.length + 2;
        _this4.loadLabels();
      }).catch(function (err) {
        _this4.$message.error('添加失败');
      });
    },
    // 添加差评标签
    addNegativeLabel: function addNegativeLabel() {
      var _this5 = this;
      if (!this.newNegativeLabel.trim()) {
        this.$message.warning('请输入标签名称');
        return;
      }
      var data = {
        labelName: this.newNegativeLabel.trim(),
        labelType: 2,
        sortOrder: this.newNegativeSort || this.negativeLabels.length + 1,
        status: 1
      };
      (0, _evaluateLabel.saveEvaluateLabel)(data).then(function () {
        _this5.$message.success('添加成功');
        _this5.newNegativeLabel = '';
        _this5.newNegativeSort = _this5.negativeLabels.length + 2;
        _this5.loadLabels();
      }).catch(function (err) {
        _this5.$message.error('添加失败');
      });
    },
    // 更新标签状态
    updateLabelStatus: function updateLabelStatus(row) {
      var _this6 = this;
      var data = {
        id: row.id,
        labelName: row.labelName,
        labelType: row.labelType,
        sortOrder: row.sortOrder,
        status: row.status
      };
      (0, _evaluateLabel.updateEvaluateLabel)(data).then(function () {
        _this6.$message.success('状态更新成功');
      }).catch(function (err) {
        _this6.$message.error('状态更新失败');
        _this6.loadLabels();
      });
    },
    // 编辑标签
    editLabel: function editLabel(row, labelType) {
      this.editLabelForm = {
        id: row.id,
        labelName: row.labelName,
        labelType: labelType,
        sortOrder: row.sortOrder,
        status: row.status
      };
      this.editLabelDialogVisible = true;
    },
    // 保存编辑标签
    saveEditLabel: function saveEditLabel() {
      var _this7 = this;
      if (!this.editLabelForm.labelName.trim()) {
        this.$message.warning('请输入标签名称');
        return;
      }
      (0, _evaluateLabel.updateEvaluateLabel)(this.editLabelForm).then(function () {
        _this7.$message.success('修改成功');
        _this7.editLabelDialogVisible = false;
        _this7.loadLabels();
      }).catch(function (err) {
        _this7.$message.error('修改失败');
      });
    },
    // 删除标签
    deleteLabel: function deleteLabel(id) {
      var _this8 = this;
      this.$confirm('确定要删除该标签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _evaluateLabel.deleteEvaluateLabel)(id).then(function () {
          _this8.$message.success('删除成功');
          _this8.loadLabels();
        }).catch(function (err) {
          _this8.$message.error('删除失败');
        });
      }).catch(function () {
        // 取消删除
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};